const defaultNavigation = ({
  isManageIAQIndexes,
  isDeveloper,
  isFieldEngineer,
  isFieldAdmin,
  isOperations,
  //isExecutive,
  isDeviceManagement,
  isDemandResponseAdmin,
  isDemandResponseUser,
  canImpersonate,
}) => {
  const elems = [];
  [
    {
      header: "My Portfolio",
    },
    {
      id: "buildingsList",
      title: "Buildings",
      icon: "List",
      navLink: "/buildingslist",
    },
    {
      id: "portfolioNotes",
      title: "Notes",
      icon: "Edit",
      navLink: "/portfolionotes",
    },
    {
      id: "portfolioReporting",
      title: "Reporting",
      icon: "BarChart2",
      navLink: "/portfolioreporting",
    },
    {
      header: "DATA",
    },
    {
      id: "Data Page",
      title: "View Data",
      icon: "Activity",
      navLink: "/data",
    },
    {
      id: "AlertsPage",
      title: "Alerts",
      icon: "AlertCircle",
      navLink: "/alerts",
    },
    ...(isDemandResponseAdmin || isDemandResponseUser
      ? [
          {
            header: "Demand Response",
          },
          {
            id: "CurtailmentExpPage",
            title: "Event Performance",
            icon: "Activity",
            navLink: "/curtailment/curtailmentexp",
          },
          /*
          {
            id: "CurtailmentHistory",
            title: "Performance History",
            icon: "BookOpen",
            navLink: "/curtailment/history",
            requiresDeveloper: true,
          },
          */
        ]
      : []),
  ]
    .filter(({ requiresDeveloper }) => !requiresDeveloper || isDeveloper)
    .map((c) => elems.push(c));
  [
    {
      header: "Energy Star",
    },
    {
      id: "EnergyStar",
      title: "Manage Energy Star",
      icon: "Star",
      navLink: "/energystar",
    },
  ]
    .filter(() => isDeveloper || isOperations)
    .map((e) => elems.push(e));
  [
    {
      header: "Setup",
    },
    {
      id: "PortfoliosPage",
      title: "Manage Portfolios",
      icon: "Package",
      navLink: "/portfolios",
    },
  ].map((e) => elems.push(e));
  [
    {
      id: "curtailmentPages",
      title: "Demand Response",
      icon: "List",
      children: [
        {
          id: "areas",
          title: "Manage Areas",
          icon: "Map",
          navLink: "/curtailment/areas",
        },
        {
          id: "contacts",
          title: "Manage Contacts",
          icon: "Users",
          navLink: "/curtailment/contacts",
        },
        {
          id: "curtailplans",
          title: "Manage Curtail Plans",
          icon: "Clipboard",
          navLink: "/curtailment/curtailplans",
        },
        {
          id: "enrollmentrecords",
          title: "Manage Enrollments",
          icon: "Loader",
          navLink: "/curtailment/enrollmentrecords",
        },
        {
          id: "programs",
          title: "Manage Programs",
          icon: "Sun",
          navLink: "/curtailment/programs",
        },
        {
          id: "resources",
          title: "Manage Resources",
          icon: "Zap",
          navLink: "/curtailment/resources",
        },
        {
          id: "mmareport",
          title: "MMA Report",
          icon: "BarChart2",
          navLink: "/curtailment/mmareport",
        },
        {
          id: "aclreport",
          title: "ACL Report",
          icon: "BarChart2",
          navLink: "/curtailment/aclreport",
          isPreview: true,
        },
        ...(isDeveloper
          ? [
              {
                id: "manageNotifications",
                title: "Manage Notifications",
                icon: "Mail",
                navLink: "/curtailment/notifications/manage",
                requiresDeveloper: true,
              },
            ]
          : []),
        {
          id: "events",
          title: "Manage Events",
          icon: "Activity",
          navLink: "/curtailment/events",
        },
        {
          id: "viewNotifications",
          title: "View Notifications",
          icon: "Bell",
          navLink: "/curtailment/notifications/view",
        },
        /*
        {
          id: "sanityCheck",
          title: "Sanity Check",
          icon: "Coffee",
          navLink: "/curtailment/sanitycheck",
        },
        */
      ],
    },
  ]
    .filter(() => isDemandResponseAdmin)
    .map((e) => elems.push(e));
  [
    {
      id: "UserManagementPage",
      title: "Users",
      icon: "Users",
      navLink: "/users",
    },
  ]
    .filter(() => isDeveloper || isOperations || canImpersonate)
    .map((e) => elems.push(e));
  [
    {
      id: "DeviceManagementDataPage",
      title: "Device Management",
      icon: "Cpu",
      navLink: "/dm",
    },
  ]
    .filter(() => isDeviceManagement)
    .map((e) => elems.push(e));
  [
    {
      id: "iaqIndex",
      title: "IAQ Indexes",
      icon: "Sliders",
      navLink: "/iaqIndex",
    },
  ]
    .filter(() => isManageIAQIndexes)
    .map((e) => elems.push(e));
  [
    {
      id: "developerPages",
      title: "Developer",
      icon: "GitHub",
      children: [
        {
          id: "JobsPage",
          title: "Scheduled Jobs",
          icon: "Watch",
          navLink: "/jobs",
        },
        {
          id: "DeveloperSandboxPage",
          title: "Developer Sandbox",
          icon: "Code",
          navLink: "/developer/sandbox",
        },
        {
          id: "buildingLayout",
          title: "Building Layout",
          icon: "Layers",
          navLink: "/buildingLayout",
        },
      ],
    },
  ]
    .filter(() => isDeveloper || isFieldEngineer || isFieldAdmin)
    .map((e) => elems.push(e));
  [
    {
      header: "Reporting",
    },
    {
      id: "Portfolio",
      title: "General Reports",
      icon: "List",
      children: [
        {
          id: "rpt_gen_portfolio",
          title: "Portfolio",
          icon: "Archive",
          navLink: "/reportingportfolio",
        },
        {
          id: "rpt_gen_utilitybills",
          title: "Utility Bills (soon)",
          icon: "DollarSign",
          navLink: "/reportingutilitybills",
        },
        {
          id: "rpt_gen_demandresponse",
          title: "Demand Response (soon)",
          icon: "Watch",
          navLink: "/reportingdemandresponse",
        },
        {
          id: "rpt_gen_iaq",
          title: "IAQ (soon)",
          icon: "Watch",
          navLink: "/reportingiaq",
        },
      ],
    },
  ]
    .filter(() => isDeveloper)
    .map((e) => elems.push(e));
  [
    {
      header: "External Sites",
    },
    {
      id: "machclassic",
      title: "MACH Classic",
      icon: "ExternalLink",
      externalLink: true,
      newTab: true,
      navLink: "https://app.machenergy.com",
    },
    {
      id: "Tedclassic",
      title: "The Energy Desk",
      icon: "ExternalLink",
      externalLink: true,
      newTab: true,
      navLink: "https://meterdata.iescorp.us",
    },
    {
      id: "homepage",
      title: "WellStat.io",
      icon: "ExternalLink",
      externalLink: true,
      newTab: true,
      navLink: "https://wellstat.io/",
    },
    // TODO: Settings Page Here ->
    {
      id: "logoutPage",
      title: "Logout",
      icon: "Power",
      navLink: "/logout",
    },
  ].map((e) => elems.push(e));
  return elems;
};

export default defaultNavigation;
